import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import type { ExpertReportResponse } from '@/entities/expert-report';
import { toastInfo } from '@/shared/lib';

/**
 * Уведомление о том, что построенные по диалогам результаты приводятся к правилам заключения в их
 * новом виде. Пересчёт идёт сам по себе: сохранение его не ждёт, а результаты до его окончания
 * показываются те, что дало прежнее правило.
 */
export const useResultsRecalculationNotice = () => {
  const { t } = useTranslation('expertReport');

  return useCallback(
    (report: ExpertReportResponse) => {
      if (report.resultsRecalculating) toastInfo(t('resultsRecalculating'));
    },
    [t],
  );
};
